// extracted by mini-css-extract-plugin
export default {"uploaderWrapper":"UploadImage_uploaderWrapper__fFqb3","selectedImageWrapper":"UploadImage_selectedImageWrapper__t5mlF"};